import { capitalize } from 'lodash';

export const displayableText = (text: string) => text.split('_').map(capitalize).join(' ');
